// ABOUTME: The one visual treatment for every inline card the assistant drops
// into the transcript (#2099). Assistant turns render unboxed, so a card is
// always the SINGLE container level: one hairline border on the plain card
// surface — no tinted washes, no shadows, no hover elevation, no card-in-card.
// Status (success/warning/error) is said by an icon + heading color, never by
// flooding the whole card with a semantic tint.

/** Base container for an inline chat card. */
export const CHAT_CARD = 'rounded-lg border bg-card p-3'

/** Base container plus the transcript rhythm every card sits on. */
export const CHAT_CARD_BLOCK = `${CHAT_CARD} my-2 space-y-2`
